export enum ReportsGroupBy {
  Month = 'month',
  PaceTaskScreen = 'paceTaskScreen',
  PaceTask = 'paceTask',
  ProgressStatus = 'progressStatus',
  ProjectStatus = 'projectStatus',
  ProjectSubtype = 'projectSubtype',
  ProjectType = 'projectType',
  ProvidenceAgent = 'providenceAgent',
  Quarter = 'quarter',
  State = 'state',
  Submarket = 'submarket',
  TowerOwner = 'towerOwner',
}
